import { css } from 'foundations-theming/utils';
export const breakpointValues = {
  hd: 1920,
  sd: 1366,
  sdMac: 1280,
  cs: 1190,
  tablet: 1024,
  tabletPortrait: 800,
  tabletPortraitLarge: 900,
  phoneLarge: 680,
  phone: 500
};
export const isBreakpointScreen = value => {
  return value in breakpointValues;
};
const breakpointScreens = Object.keys(breakpointValues);
export const minWidthBreakpoint = breakpointScreens.reduce((acc, label) => {
  acc[label] = (template, ...args) => css(["@media (min-width:", "em){", "}"], (breakpointValues[label] + 1) / 16, css(template, ...args));
  return acc;
}, {});
export const breakpoint = breakpointScreens.reduce((acc, label) => {
  acc[label] = (template, ...args) => css(["@media (max-width:", "em){", "}"], breakpointValues[label] / 16, css(template, ...args));
  return acc;
}, {});
export const trellisBreakpoint = breakpointScreens.reduce((acc, label) => {
  acc[label] = `@media (max-width: ${breakpointValues[label] / 16}em)`;
  return acc;
}, {});

// Can be more type-strict:https://developer.mozilla.org/en-US/docs/Web/CSS/@media#media_features

export const mediaQueries = breakpointScreens.reduce((acc, label) => {
  acc[label] = `(max-width: ${breakpointValues[label] / 16}em)`;
  return acc;
}, {});